/**
 * servicios menus y contenido
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * Contact: csgj@gft.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Registeruser {
  nombre?: string;
  apellido1?: string;
  apellido2?: string;
  pais?: string;
  idioma?: string;
  empresa?: string;
  actividad?: string;
  email?: string;
}
